import AlfieIcon from "~/components/icons/alfie-icon";
import { Button } from "@workspace/web-ui/components/button";

interface PageHeaderProps {
  title: string;
  buttonLable?: string;
  onClick?: () => void;
  username?: string;
  description?: string;
}

const PageHeader = ({ title, buttonLable, onClick, username, description }: PageHeaderProps) => {
  return (
     <nav className="">
      <span className="inline-flex gap-2 ">
          <h6 className="text-lg font-normal">Welcome,</h6>
          <h6 className="text-lg font-bold">{username}</h6>
      </span>
      <div className="flex flex-col sm:flex-row lg:gap-0 gap-3 justify-between items-start sm:items-center mb-6">
            <div>      
                <h1 className="lg:text-[40px] text-[24px] font-bold lg:leading-[140%] tracking-[-2%] text-[#1A202C]">{title}</h1>
                <p className="text-[#464B55] text-[14px] lg:leading-[140%] tracking-[-1%] font-normal">{description}</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                <Button onClick={onClick} variant="outline" style={{boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.1)"}}  className="border-[#DCDCDE] h-auto text-[#202020CC] !py-[12px] !px-[16px] rounded-[8px]" >
                <AlfieIcon />   {buttonLable}
                </Button>
            </div>
      </div>
    </nav>

  );
};

export default PageHeader;
